module.exports = __webpack_public_path__ + "static/img/zlm-logo.6f8f100.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zlm-logo.png
// module id = HLUB
// module chunks = 1